module.exports = __webpack_public_path__ + "448b2233ac7fa7a3d528714d1226ed21.png";